import { createFileRoute } from "@tanstack/react-router";

import { ReengagementEmailsDashboard } from "../tools/dashboards/ReengagementEmailsDashboard";

function ReengagementEmailsRoute() {
  return <ReengagementEmailsDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/reengagement-emails")({
  component: ReengagementEmailsRoute,
});
